import { createSelector } from 'reselect';

const selectBecauseYouShopped = state => state.becauseYouShopped;

const selectBecauseYouShoppedSet = (state, merchantId) => (
  state.becauseYouShopped[merchantId] || {}
);

export const selectBecauseYouShoppedConfig = createSelector(
  selectBecauseYouShopped,
  becauseYouShopped => becauseYouShopped.config,
);

export const makeSelectBecauseYouShoppedSetOfMerchants = () => (
  createSelector(
    selectBecauseYouShoppedSet,
    becauseYouShoppedSet => becauseYouShoppedSet.merchants,
  )
);

export const makeSelectBecauseYouShoppedSetIsLoading = () => (
  createSelector(
    selectBecauseYouShoppedSet,
    becauseYouShoppedSet => becauseYouShoppedSet.isLoading,
  )
);

export const makeSelectBecauseYouShoppedSetIsLoaded = () => (
  createSelector(
    selectBecauseYouShoppedSet,
    becauseYouShoppedSet => becauseYouShoppedSet.isLoaded,
  )
);
